@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/spacers';
@import '@helsenorge/designsystem-react/scss/breakpoints';

$button-background: linear-gradient(90deg, #fffefc 0%, #fece99 100%);
$button-hover-bg: #ffca8c;
$button-secondary-bg: none;
$horizontal-padding: 2;
$button-padding-left-right: 2.18rem;
$button-padding-left-right-md: 30px;

.button {
  $button: &;

  position: relative;
  z-index: 10;
  border: none;
  padding: 1.5rem $button-padding-left-right;
  font-size: 1.5rem;
  font-family: Avenir, Montserrat, Poppins, serif;
  font-weight: 500;
  text-align: left;
  display: flex;
  line-height: 1;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10rem;
  cursor: pointer;

  @media (max-width: map.get($grid-breakpoints, md)) {
    padding: 10px $button-padding-left-right-md;
    font-size: 18px;
  }

  &--fluid {
    width: 100%;
  }

  &--main {
    background: $button-background;
    padding: 10px 30px;
    font-family: Avenir, Montserrat, Poppins, serif;
    min-height: 64px;
    font-size: 22px;
    font-weight: 500;

    &:hover,
    &:focus {
      text-decoration: underline;
      background: #e5ba8c;
    }

    &:focus {
      box-shadow: inset 0 0 0 2px #fff;
      outline: none;
    }

    @media (max-width: map.get($grid-breakpoints, md)) {
      font-size: 20px;
    }
  }

  &--main-large {
    background: $button-background;
    justify-content: space-between;
    min-width: 52.5rem;
    padding: 2.25rem 5rem 2.25rem 5.3rem;

    @media (max-width: map.get($grid-breakpoints, xl)) {
      max-width: 23.75rem;
      min-width: unset;
      padding: 25px 35px;
    }

    &:hover,
    &:focus {
      background: #e5ba8c;
    }

    &:focus {
      box-shadow: inset 0 0 0 2px #fff;
      outline: none;
    }
  }

  &--secondary {
    padding-left: 0;
    padding-right: 1rem;
    background-color: transparent;
    margin-left: -0.5rem;

    @media (max-width: map.get($grid-breakpoints, md)) {
      margin-left: -0.35rem;
    }

    &--right {
      padding-left: 1rem;
      padding-right: 0;
    }
  }

  &--secondary-top-menu {
    margin-left: -0.7rem;

    @media (max-width: map.get($grid-breakpoints, md)) {
      margin-left: -0.4rem;
    }
  }

  &--link {
    font-size: 1.5rem;
    line-height: 2.25rem;
    width: fit-content;
    background-color: transparent;
    margin: 0 calc($button-padding-left-right * -1);

    @media (max-width: map.get($grid-breakpoints, xl)) {
      font-size: 0.875rem;
      line-height: 1.3rem;
    }

    @media (max-width: map.get($grid-breakpoints, md)) {
      margin: 0 calc($button-padding-left-right-md * -1);
    }
  }

  &--inverted {
    color: #000;

    &:focus-visible {
      outline-color: #000;
    }
  }

  &--inverted#{&}--main,
  &--inverted#{&}--main-large {
    background: linear-gradient(90deg, #baeae4, #87d2d1);
    margin-bottom: 0;

    &:hover,
    &:focus {
      background: #53cdd6;
    }

    &:focus {
      box-shadow: inset 0 0 0 2px #fff;
      outline: none;
    }
  }

  &__icon {
    transition: transform 0.4s;
  }

  &:hover &__icon,
  &:focus &__icon {
    transform: translateX(3.1rem);

    @media (max-width: map.get($grid-breakpoints, xl)) {
      transform: translateX(1.25rem);
    }
  }

  &__title {
    font-weight: 900;
    font-size: 2.5rem;
    line-height: 54px;
    margin-bottom: 4px;
    #{$button}:hover &,
    #{$button}:focus & {
      text-decoration: underline;
    }

    @media (max-width: map.get($grid-breakpoints, xl)) {
      font-size: 1.25rem;
      line-height: 26px;
    }
  }

  &__label--main {
    @media (max-width: map.get($grid-breakpoints, md)) {
      text-align: left;
    }
  }

  &__label--link {
    text-decoration: underline;
  }

  &__label--secondary,
  &__label--link {
    :hover > &,
    :focus > & {
      text-decoration: underline;
      font-weight: 600;
    }
  }
}
